var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"1","width":"36","height":"36","rx":"18","stroke":"#262626","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M26.8492 11.1508C26.4976 10.7993 25.9281 10.7993 25.5765 11.1508L18.9999 17.7274L12.4233 11.1508C12.0717 10.7993 11.5022 10.7993 11.1506 11.1508C10.7991 11.5024 10.7991 12.0719 11.1506 12.4235L17.7272 19.0001L11.1506 25.5767C10.7991 25.9283 10.7991 26.4978 11.1506 26.8493C11.5022 27.2009 12.0717 27.2009 12.4233 26.8493L18.9999 20.2727L25.5765 26.8493C25.9281 27.2009 26.4976 27.2009 26.8492 26.8493C27.2007 26.4978 27.2007 25.9283 26.8492 25.5767L20.2726 19.0001L26.8492 12.4235C27.2007 12.0719 27.2007 11.5024 26.8492 11.1508Z","fill":"#262626","key":1})]);
}

CloseInline.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
